// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../../../../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n._2rko12b0{border-radius:var(--ds-radius-small,4px)}._189e1dm9{border-width:var(--ds-border-width-selected,2px)}\n._189ee4h9{border-width:var(--ds-border-width,1px)}\n._1dqonqa1{border-style:solid}\n._1h6d15qp{border-color:var(--ds-border-accent-blue,#1d7afc)}\n._1h6dmuej{border-color:var(--ds-border,#091e4224)}\n._4t3i1f4h{height:28px}", ""]);
// Exports
module.exports = exports;
